/** @typedef {import("../types/types").Coordinates} Coordinates */

/**
 * @param {HTMLElement} element
 * @returns {Coordinates}
 */
export function getTranslateCoordinates(element) {
  const transform = element.style.transform;
  if (!transform) {
    return { x: 0, y: 0 };
  }
  const match = /translate\((-?\d+\.?\d*)px, (-?\d+\.?\d*)px\)/g.exec(
    transform,
  );
  if (match === null) {
    return { x: 0, y: 0 };
  }
  const x = Number.parseFloat(match[1]);
  const y = Number.parseFloat(match[2]);
  return {
    x: Number.isFinite(x) ? x : 0,
    y: Number.isFinite(y) ? y : 0,
  };
}

export function translateValueForCoordinates({ x = 0, y = 0 }) {
  return `translate(${x === 0 ? 0 : `${x}px`}, ${y === 0 ? 0 : `${y}px`})`;
}

/**
 * @param {HTMLElement} element
 * @param {Coordinates} coordinates
 */
export function setTranslate(element, coordinates) {
  element.style.setProperty(
    "transform",
    translateValueForCoordinates(coordinates),
  );
}

/**
 * @param {HTMLElement} element
 * @param {number} x
 */
export function setTranslateX(element, x) {
  const { y } = getTranslateCoordinates(element);
  setTranslate(element, { x, y });
}

/**
 * @param {HTMLElement} element
 * @param {number} y
 */
export function setTranslateY(element, y) {
  const { x } = getTranslateCoordinates(element);
  setTranslate(element, { x, y });
}
